// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ModeSwitcher from "./components/modeswitcher";
import NewApp from "./pages/NewApp";
import OldApp from "./pages/OldApp";
import VroomApp from "./pages/VroomApp/vroomapp";

function App() {
  return (
    <Router>
      <ModeSwitcher />
      <Routes>
        <Route path="/" element={<NewApp />} />
        <Route path="/old" element={<OldApp />} />
        <Route path="/vroom" element={<VroomApp />} />
      </Routes>
    </Router>
  );
}

export default App;
